export default __webpack_public_path__ + "static/media/imagetoword.bfb31179.png";